import { FC } from 'react';
import { Badge, useMantineTheme } from '@mantine/core';
import Moment from 'react-moment';
import { DocumentDto } from '../../../Service/DocumentT';
import { DocumentS } from '../../../Templates/Documents/DocumentS';

const DocumentExpirationBadge: FC<{ bookitupDocument: DocumentDto }> = ({ bookitupDocument }) => {
  const { draft, documentType, validUntil, paid } = bookitupDocument;
  const { colorScheme, colors } = useMantineTheme();
  const isInvoice = DocumentS.isInvoice(documentType) || documentType === 'CANCEL';

  if (!validUntil) {
    return null;
  }
  const expired = new Date().getTime() > new Date(validUntil).getTime();

  const getColors = () => {
    if (documentType === 'OFFER') {
      if (!draft) {
        return ['white', 'green'];
      }
      if (expired && draft) {
        return ['white', 'red'];
      }
      return ['black', colorScheme === 'dark' ? colors.gray[5] : colors.gray[2]];
    }
    if (paid) {
      return ['white', colorScheme === 'dark' ? colors.green[8] : colors.green[4]];
    }
    if (expired && !paid) {
      return ['white', 'red'];
    }
    return ['black', colorScheme === 'dark' ? colors.gray[5] : colors.gray[2]];
  };

  const [fontColor, bgColor] = getColors();

  return (
    <Badge
      sx={{
        color: fontColor,
        fontSize: 10,
        textTransform: 'none',
        fontWeight: 'lighter',
        backgroundColor: bgColor,
      }}
    >
      {isInvoice ? 'Zahlung' : 'Gültig'} bis{' '}
      <b>
        <Moment date={validUntil} format="DD.MM" />
      </b>
    </Badge>
  );
};

export default DocumentExpirationBadge;
